import React, {
  memo, useCallback, useRef, useState,
} from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import removeParamsFormHash from "@utils/removeParamasFromHash";
import { IconChevronDown, IconChevronUp } from "@searchComponents/icons";
import { setFilter } from "../store/actions";
import FilterItem from "./FilterItem";
import styles from "../../../styles/components/filter.module.scss";

const FilterCard = memo(({
  title, parentValue, content = [], selected,
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const filterCard = useRef(null);
  const [arrowDirection, setArrowDirection] = useState("down");
  const handleClick = useCallback((value, active) => {
    if (active) {
      return dispatch(setFilter(removeParamsFormHash(history.location.hash.replace("#", ""), value), true));
    }
    dispatch(setFilter(`${parentValue}=${value}`));
  }, []);

  const handleKeyDown = (event, value, active) => {
    if (!["Enter", "Space"].includes(event.code)) {
      return;
    }

    event.preventDefault();

    handleClick(value, active);
  };

  const toggleFilter = () => {
    if ([...filterCard.current.classList].includes("active-filter")) {
      setArrowDirection("down");
      setTimeout(() => {
        filterCard.current.style.display = "block";
      }, 205);
    } else {
      setArrowDirection("up");
      setTimeout(() => {
        filterCard.current.style.display = "none";
      }, 205);
    }
    filterCard.current.classList.toggle("active-filter");
  };

  if (content.length) {
    return (
            <div className={styles.card}>
                <div className={styles.bar} onClick={toggleFilter}>
                    <p className={styles.title}>{title}</p>
                    {arrowDirection === "down"
                      ? <IconChevronDown/>
                      : <IconChevronUp/>
                    }
                </div>
                <div
                    ref={filterCard}
                    className={`${styles.content} filter__card-content--flex filter__card-content--flex-wrap filter__card-content--margin-item default-filter`}>
                    {content.map(({ value, label, count }) => <FilterItem
                        active={selected[value]}
                        key={value}
                        name={label}
                        rightText={count}
                        value={value}
                        handleClick={handleClick}
                        handleKeyDown={handleKeyDown}
                    />)}
                </div>
            </div>
    );
  }
  return null;
});

export default FilterCard;
